/* KBW Cabinet PDP — EKRAN 3

   A cabinet's nine widths are nine products and its four finished ends are four
   more. Neither is a variant, so neither can be an option dropdown — both are
   lists of siblings, and Liquid on a product page cannot ask a collection for
   the siblings of one cabinet type: `collection.products` there is unfiltered
   and capped. So both controls are built from one fetch of the style
   collection, filtered server side, and both stay hidden if it never arrives —
   leaving a page that still sells the exact cabinet whose URL you are on.

   Choosing one of them is a real move to a different product, and it happens
   without a reload. The sibling's page is fetched, this section's markup is
   swapped for its markup, and the title, the canonical link and the URL are
   moved with it. Everything on the page is then the new cabinet's: the heading,
   the drawing, the SKU, the details card, the structured data. That matters
   more here than it looks — swapping only the price and the SKU in place left
   a heading still reading NO FINISH above a chosen finished end.

   The two feeds are cached by URL. Every width and every finished end of one
   cabinet shares a feed, so after the first fetch a change costs one request
   for the page and nothing else.

   Custom section script — not part of the Maximize theme. */

(function () {
  'use strict';

  var KAP = document.querySelector('[data-kbw-pdp]');
  if (!KAP) return;

  /* The stable ancestor. The root carries the product's own data attributes, so
     it is replaced wholesale on every swap and cannot be held onto. */
  var yuva = KAP.parentElement;
  var kok = KAP;
  var bellek = {};

  var q = function (s) { return kok.querySelector(s); };

  var ETIKET = {
    '': 'No finished end',
    'Unfinished': 'No finished end',
    'Left Side': 'Left side finished',
    'Right Side': 'Right side finished',
    'Both Sides': 'Both sides finished'
  };
  var SIRA = ['Unfinished', '', 'Left Side', 'Right Side', 'Both Sides'];

  function para(ornek, kurus) {
    /* Every row carries a price Liquid already formatted, so the shop's symbol
       is borrowed from one of them rather than guessed. An upcharge written as
       a bare 38.28 beside prices written as $501.72 reads as a different unit. */
    var sembol = ((ornek || '').match(/^[^\d]*/) || [''])[0];
    return sembol + (kurus / 100).toFixed(2);
  }

  /* A preview is a query parameter, not a theme the store has published, so
     every link built here has to carry it or the swap lands on the live theme. */
  function suslu(url) {
    var simdi = new URLSearchParams(location.search);
    var hedef = new URL(url, location.origin);
    ['view', 'preview_theme_id', '_ab', '_fd', '_sc'].forEach(function (k) {
      if (simdi.has(k) && !hedef.searchParams.has(k)) {
        hedef.searchParams.set(k, simdi.get(k));
      }
    });
    return hedef.pathname + hedef.search;
  }

  function belgeGetir(url) {
    if (bellek[url]) return Promise.resolve(bellek[url]);
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        bellek[url] = doc;
        return doc;
      });
  }

  /* --- Moving to a sibling ------------------------------------------------ */

  var mesgul = false;

  function gecis(url, gecmiseYaz) {
    if (mesgul) return;
    var hedef = suslu(url);
    mesgul = true;
    kok.classList.add('is-loading');

    /* The whole document, not just this section. A different product is a
       different title, canonical and description, and leaving those behind
       would leave the address bar telling the truth while the head lies. */
    fetch(hedef, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var yeni = doc.querySelector('[data-kbw-pdp]');
        if (!yeni) throw new Error('section missing');

        kok.replaceWith(yeni);
        kok = yuva.querySelector('[data-kbw-pdp]');

        if (doc.title) document.title = doc.title;
        basKopyala(doc, 'link[rel="canonical"]', 'href');
        basKopyala(doc, 'meta[name="description"]', 'content');

        if (gecmiseYaz) {
          history.pushState({ kbwPdp: true }, '', hedef);
        }
        kur();
      })
      .catch(function () {
        /* A navigation that cannot be faked is still a navigation. */
        window.location.href = hedef;
      })
      .then(function () { mesgul = false; });
  }

  function basKopyala(doc, sec, alan) {
    var kaynak = doc.querySelector(sec);
    var mevcut = document.querySelector(sec);
    if (!kaynak || !mevcut) return;
    mevcut.setAttribute(alan, kaynak.getAttribute(alan));
  }

  /* The entry the page loaded on has no state of its own, so going back to it
     would fire a popstate this handler ignores — leaving the address bar on the
     first cabinet and the page showing the last one. Marking it fixes that. */
  history.replaceState({ kbwPdp: true }, '', location.pathname + location.search);

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.kbwPdp) gecis(location.pathname + location.search, false);
  });

  /* --- Gallery ------------------------------------------------------------ */

  function galeriKur() {
    var thumbs = [].slice.call(kok.querySelectorAll('[data-kbw-pdp-thumb]'));
    if (thumbs.length < 2) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-kbw-pdp-thumb');
        thumbs.forEach(function (o) { o.classList.toggle('is-on', o === t); });
        kok.querySelectorAll('[data-kbw-pdp-shot]').forEach(function (s) {
          s.classList.toggle('is-on', s.getAttribute('data-kbw-pdp-shot') === i);
        });
      });
    });
  }

  /* --- Quantity ----------------------------------------------------------- */

  function adetKur() {
    var alan = q('[data-kbw-pdp-qty]');
    if (!alan) return;
    var kaydir = function (n) {
      var v = (parseInt(alan.value, 10) || 1) + n;
      alan.value = v < 1 ? 1 : v;
    };
    var eksi = q('[data-kbw-pdp-minus]');
    var arti = q('[data-kbw-pdp-plus]');
    if (eksi) eksi.addEventListener('click', function () { kaydir(-1); });
    if (arti) arti.addEventListener('click', function () { kaydir(1); });
    alan.addEventListener('change', function () {
      if ((parseInt(alan.value, 10) || 0) < 1) alan.value = 1;
    });
  }

  /* --- Siblings ----------------------------------------------------------- */

  function aileKur() {
    var stilUrl = kok.getAttribute('data-style-url') || '';
    /* `sub_category`, not `sub_type`.
       Both name the kind of cabinet, but only one of them is switched on as a
       storefront filter -- `filter.p.m.kbw.sub_type` was silently ignored, so
       the fetch came back with the whole style: 244 unrelated products became
       the width chips and every one of them sharing a width became a finished
       end option. `sub_type` is the maker's own wording and is documented as
       not shown on the site; `sub_category` is our vocabulary, already
       filterable, and is exactly the set of cabinets that differ only in
       width. */
    var altKat = kok.getAttribute('data-sub-category') || '';
    if (!stilUrl || !altKat) return;

    var url = suslu(stilUrl + '?section_id=kbw-pdp-family' +
      '&filter.p.m.kbw.sub_category=' + encodeURIComponent(altKat));

    belgeGetir(url).then(function (doc) {
      var satirlar = [].slice.call(doc.querySelectorAll('.kbw-pdpf__row'));
      if (!satirlar.length) return;
      olcuYaz(satirlar);
      cilaYaz(satirlar);
    }).catch(function () { /* Hidden is the safe state; the page still sells. */ });
  }

  function baglantiYap(r, sinif) {
    var a = document.createElement('a');
    a.className = sinif;
    a.href = suslu(r.getAttribute('data-url'));
    if (r.getAttribute('data-handle') === kok.getAttribute('data-handle')) {
      a.classList.add('is-on');
      a.setAttribute('aria-current', 'page');
    }
    /* Left a real link on purpose: a middle click, a right click, a crawler and
       a browser with the script disabled all still get a working URL. */
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      gecis(a.getAttribute('href'), true);
    });
    return a;
  }

  function olcuYaz(satirlar) {
    var kutu = q('[data-kbw-pdp-sizes]');
    var liste = q('[data-kbw-pdp-sizelist]');
    if (!kutu || !liste) return;

    /* A sibling is a record that differs from this cabinet in WIDTH ALONE:
       same finish line, same height, same depth. Anything else is a different
       cabinet that happens to be the same number of inches across.

       This used to group on width alone and then, when several records shared
       a width, take the CHEAPEST. Both halves were wrong. The feed is filtered
       by `kbw.sub_category`, which is a cabinet-type vocabulary spanning every
       height and every finish line, and the tie-break that was meant to
       separate them — `finished_side` — is blank on essentially the whole
       catalogue, so it never discriminated and the cheapest always won. A 36"
       chip on a 36"x18" wall cabinet was showing the price of a 12"-tall
       cabinet from another finish line. Measured on live data 2026-09-23: 180
       of 182 products in one group wrong, 78 of 82 in another.

       Height and depth now come through the feed, so the key is exact. What is
       left over is the honest part: if a width has more than one candidate
       after the exact key, the page cannot know which one the customer means,
       and if it has none there is nothing to point at. Either way NO CHIP IS
       DRAWN for that width. A missing option costs a click; a wrong price on a
       chip costs an order. */
    var anahtar = function (yan, yuk, der) {
      return (yan || '') + '¦' + (yuk || '') + '¦' + (der || '');
    };
    var buAnahtar = anahtar(
      kok.getAttribute('data-side'),
      kok.getAttribute('data-height'),
      kok.getAttribute('data-depth')
    );

    var adaylar = {};
    satirlar.forEach(function (r) {
      var w = r.getAttribute('data-w');
      if (!w || w === '0') return;
      if (anahtar(r.getAttribute('data-side'), r.getAttribute('data-h'), r.getAttribute('data-d')) !== buAnahtar) return;
      (adaylar[w] = adaylar[w] || []).push(r);
    });

    var genislikler = Object.keys(adaylar).filter(function (w) {
      return adaylar[w].length === 1;
    }).sort(function (a, b) { return Number(a) - Number(b); });
    if (genislikler.length < 2) return;

    liste.textContent = '';
    genislikler.forEach(function (w) {
      var r = adaylar[w][0];
      var a = baglantiYap(r, 'kbw-pdp__chip');
      var b = document.createElement('b');
      b.textContent = r.getAttribute('data-wt') || (w + '"');
      var s = document.createElement('span');
      s.textContent = r.getAttribute('data-price-text') || '';
      a.appendChild(b);
      a.appendChild(s);
      liste.appendChild(a);
    });
    kutu.hidden = false;
  }

  function cilaYaz(satirlar) {
    var kutu = q('[data-kbw-pdp-finishes]');
    var liste = q('[data-kbw-pdp-finishlist]');
    if (!kutu || !liste) return;

    /* Only the records of this exact cabinet — same width. Anything else is a
       different cabinet that happens to share a name. */
    var buW = kok.getAttribute('data-width') || '0';
    var kardes = satirlar.filter(function (r) { return r.getAttribute('data-w') === buW; });
    if (kardes.length < 2) return;

    /* A choice needs at least two things to choose between, and they have to
       be different things. The supplier does not publish which side is
       finished -- the field is empty on every one of the catalogue's rows --
       so without this the panel offered a column of identically labelled
       options that differed only in price. An empty choice is worse than no
       choice: it reads as a decision the buyer has to make and cannot. */
    var yuzler = {};
    kardes.forEach(function (r) {
      var y = r.getAttribute('data-side') || '';
      if (y) yuzler[y] = true;
    });
    if (Object.keys(yuzler).length < 2) return;

    kardes.sort(function (a, b) {
      return SIRA.indexOf(a.getAttribute('data-side')) - SIRA.indexOf(b.getAttribute('data-side'));
    });

    var taban = Math.min.apply(null, kardes.map(function (r) {
      return Number(r.getAttribute('data-price')) || 0;
    }));
    var ornek = kardes[0].getAttribute('data-price-text') || '';

    liste.textContent = '';
    kardes.forEach(function (r) {
      var yuz = r.getAttribute('data-side') || '';
      var fark = (Number(r.getAttribute('data-price')) || 0) - taban;

      /* Same chip as the widths above. Four finishes in a column of full
         width rows was a lot of page for four short words, and the two rows
         are the same kind of choice -- they should look like it. */
      var a = baglantiYap(r, 'kbw-pdp__chip');
      var b = document.createElement('b');
      b.textContent = ETIKET[yuz] || yuz;
      var s2 = document.createElement('span');
      s2.textContent = fark > 0 ? '+' + para(ornek, fark) : 'Included';

      a.appendChild(b);
      a.appendChild(s2);
      liste.appendChild(a);
    });
    kutu.hidden = false;
  }

  /* --- Similar ------------------------------------------------------------ */

  function benzerKur() {
    var kutu = q('[data-kbw-pdp-similar]');
    var liste = q('[data-kbw-pdp-similarlist]');
    var stilUrl = kok.getAttribute('data-style-url') || '';
    var sinif = kok.getAttribute('data-product-type') || '';
    var altTip = kok.getAttribute('data-sub-type') || '';
    if (!kutu || !liste || !stilUrl || !sinif) return;

    var kac = Number(kok.getAttribute('data-similar-count')) || 4;
    var url = suslu(stilUrl + '?section_id=kbw-pdp-similar' +
      '&filter.p.m.kbw.product_type=' + encodeURIComponent(sinif));

    var sec = function (doc) {
      return [].slice.call(doc.querySelectorAll('.kbw-pdps__card'))
        .filter(function (c) { return c.getAttribute('data-sub-type') !== altTip; })
        .slice(0, kac);
    };

    belgeGetir(url).then(function (doc) {
      var kartlar = sec(doc);
      if (kartlar.length) return kartlar;

      /* Ayni sinifta baska bir tip cikmadi. Bu kural ince veriyle karsilasinca
         sessizce bosaliyor: Parriott stillerinde her sinifta TEK alt tip var
         ("Base Cabinet" hepsi), yani bir base dolabin sayfasinda onerilecek
         baska base kalmiyor ve altmis stilin hicbirinde oneri cikmiyordu.

         O zaman sinif kisitini birakip ayni stilin geri kalanina bakiyoruz —
         mutfak kuran biri icin Wall ve Tall zaten siradaki adim. Ikinci istek
         yalnizca birincisi bos donunce yapiliyor. */
      return belgeGetir(suslu(stilUrl + '?section_id=kbw-pdp-similar')).then(sec);
    }).then(function (kartlar) {
      if (!kartlar || !kartlar.length) return;
      liste.textContent = '';
      kartlar.forEach(function (c) {
        var kopya = c.cloneNode(true);
        kopya.setAttribute('href', suslu(kopya.getAttribute('href')));
        liste.appendChild(kopya);
      });
      kutu.hidden = false;
    }).catch(function () { /* No suggestions is better than a broken row. */ });
  }

  /* --- Add to cart --------------------------------------------------------- */

  var toastEl = null;
  var toastZaman = null;

  function toast(mesaj) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'kbw-pdp__toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = mesaj;
    toastEl.classList.add('is-on');
    clearTimeout(toastZaman);
    toastZaman = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function sepeteKur() {
    var form = q('[data-kbw-pdp-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cta = q('[data-kbw-pdp-cta]');
      var kimlik = q('[data-kbw-pdp-id]');
      var adet = q('[data-kbw-pdp-qty]');
      if (!kimlik || !kimlik.value) return;

      var eskiMetin = cta ? cta.textContent : '';
      if (cta) { cta.disabled = true; cta.textContent = 'Adding…'; }

      var kokYol = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var yardimci = window.xCartHelper;
      var drawer = document.querySelector('#CartDrawer');
      var bolumler = [];
      if (yardimci && typeof yardimci.getSectionsToRender === 'function') {
        bolumler = yardimci.getSectionsToRender(drawer && drawer.dataset.sectionId) || [];
      }

      fetch(kokYol + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          /* KBW: assembly option. Ticked, the cart gets a SECOND line — the fee
             variant, at this cabinet's own quantity, carrying this cabinet's
             name — and the cabinet's own line is untouched. kbw-assembly.js
             owns that rule; this file only posts what it hands back, so the
             listing and the product page can never drift apart on it. */
          /* The surcharge goes in BEFORE its cabinet: the cart lists the most
             recently added line first, so the cabinet sent last is drawn on top
             with its surcharge indented underneath, which is what the design
             shows. Observed behaviour rather than a documented guarantee — the
             surcharge also names its cabinet in words, so the worst a change
             could do is look odd, never mislead. */
          items: (window.KbwAssembly
            ? window.KbwAssembly.extra(form, Number(adet && adet.value) || 1)
            : []).concat([{ id: Number(kimlik.value), quantity: Number(adet && adet.value) || 1 }]),
          sections: bolumler.map(function (s) { return s.id; })
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (cevap) {
          if (cevap.status && cevap.status !== 200) throw new Error(cevap.description || 'cart');

          /* The cart icon, its badge and the drawer are sections Shopify just
             re-rendered; swapping their markup moves the count without a
             reload. The drawer is not opened — adding is not a request to
             leave the page you are shopping on. */
          bolumler.forEach(function (s) {
            var el = document.querySelector(s.selector);
            var html = cevap.sections && cevap.sections[s.id];
            if (!el || !html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            el.innerHTML = (doc.querySelector(s.selector) || doc.body).innerHTML;
          });
          if (yardimci && typeof yardimci.updateCurrentCountItem === 'function') {
            yardimci.updateCurrentCountItem();
          }
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true, detail: { isItemCountChanged: true }
          }));

          var sku = (q('[data-kbw-pdp-sku]') || {}).textContent || 'Cabinet';
          toast(sku.trim() + ' × ' + (Number(adet && adet.value) || 1) + ' added to cart');
        })
        .catch(function () { toast('Could not add that to the cart — please try again'); })
        .then(function () {
          if (cta) { cta.disabled = false; cta.textContent = eskiMetin; }
        });
    });
  }

  /* Everything binds to the markup currently in the page, so a swap re-runs the
     lot. Nothing here holds a reference across one. */
  function kur() {
    kok.classList.remove('is-loading');
    /* KBW: assembly option. A size or finish chip replaces this whole section
       with the sibling cabinet's markup, and `shopify:section:load` does not
       fire for that — so the new control has to be bound here with everything
       else, or it would render visibly dead. */
    if (window.KbwAssembly) window.KbwAssembly.refresh();
    galeriKur();
    adetKur();
    sepeteKur();
    aileKur();
    benzerKur();
  }

  kur();
}());
